import { Select } from '../../../main/components'
import { Icon } from '../../../main/components/icon'
import { useChartTypes } from './use-chart-type'

const hasRedesign = FinvizSettings.hasRedesignEnabled

export function ChartTypesSelect({ isPremium }: { isPremium: boolean }) {
  const { chartTypes, currentType, setSelectedChartTypeOverwrite } = useChartTypes({ isPremium })

  return (
    <Select
      size="medium"
      data-testid="chart-type-select"
      aria-label="Chart type"
      className="w-[7.25rem]"
      value={currentType}
      leftContent={currentType ? <Icon name={currentType.icon} className="text-gray-300" /> : undefined}
      rounding={hasRedesign ? undefined : 'none'}
      onChange={({ value }) => setSelectedChartTypeOverwrite(value)}
      items={chartTypes}
    />
  )
}
